export default {

    Clients: 'العميل|العملاء',
};
